import BasicInfo from 'components/Dashboard/cards/common/BasicInfo'

type SectionProps = {
  sectionName: string
  title: string
  address: string
  state?: string
  phone: string
  className?: string
}

const Section = ({ sectionName, title, address, state, phone, className }: SectionProps) => {
  return (
    <div className={className}>
      <p className="typography-caption text-neutral-500">{sectionName}</p>
      <p className="mt-1.5 mb-2 typography-body-xl font-medium text-neutral-700 tracking-tight">{title}</p>
      <BasicInfo address={address} state={state} phone={phone} />
    </div>
  )
}

export default Section
